<div class="d-inline-block col-12 p-0 {{lite ? 'lite-mode' : ''}}" [ngClass]="finish ? null : 'newColumns'">
  <div class="mat-panel p-2 mb-0 pb-xl-3 customBg" id="contentUpload" [ngStyle]="{'padding': finish ? '0' : null }"
    [ngClass]="finish ? 'contentClass' : null">
    <div class="mat-panel-header d-flex justify-content-between align-items-center">
      <div class="cardHeader">
        <span [class.opacity]="disableAditionalDocuments" [ngClass]="finish ? 'textFont' : null">{{ header }}</span>
        <mat-icon *ngIf="hasTooltip" class="helpIcon" matTooltip="{{helpText}}"
          matTooltipPosition="above">info</mat-icon>
      </div>
      <button id="addAdded" mat-icon-button *ngIf="lite" (click)="openDialog()"
        [matTooltip]="'newcircuit_label_seleccionar' | translate:_transParam"
        [ngStyle]="{'color': finish ? '#00222D' : 'primary' }">
        <mat-icon>add_circle</mat-icon>
      </button>
    </div>
    <input #fileInput type="file" [multiple]="isMultiple()" hidden [accept]="accept" (change)="onFileSelect($event)"
      (focus)="onFocus()" (blur)="onBlur()">
    <div #contenedor (dragenter)="onDragEnter()" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)"
      (dragover)="onDragOver($event)" [ngClass]="{'mat-panel-body': true, 'py-3': !lite, 'py-1': lite}"
      id="sectionDocs">
      <mat-progress-bar *ngIf="loading" [color]="'primary'" mode="indeterminate"></mat-progress-bar>

      <div *ngIf="error" class="error-container">
        <p class="font-weight-bold error-title">
          <em class="material-icons">error_outline</em> {{'texto_error_titulo' | translate:_transParam }}
        </p>
        <p>{{('filesupload_error_'+error)| translate: {valueParam: errorParam} }}</p>
      </div>
      <div class="warning" *ngIf="!isValid">
        <mat-icon class="warning_warningIcon">warning</mat-icon>
        <p class="warning_warningText" [innerHTML]="'files_upload.text.warning' | translate : {minPage: minPage}"></p>
      </div>
      <div *ngIf="type == 'primary' || !type" cdkDropList (cdkDropListDropped)="dropDocs($event)" class="containerDocs">
        <mat-list *ngIf="files.length">
          <mat-list-item id="cursorDrag" cdkDrag [ngClass]="finish ? 'uploaddocs' : 'uploaddocsnew'"
            *ngFor="let doc of files, let i=index">
            <div mat-line class="my-auto d-md-inline-flex selectedFile">
              <div [matTooltip]="doc.name" class="uploaddocs__nameDoc">
                {{doc.name}}
              </div>
              <div class="uploaddocs__sizeDoc">
                {{doc.size | fileSize}}
              </div>
              <div>
                <button *ngIf="canRemoveDocument(i)" id="removeDelete" mat-icon-button (click)="remove($event, i);">
                  <mat-icon [ngClass]="finish ? 'deleteIconFinish' : 'deleteIconNew'"
                    class="deleteIcon">delete_outline</mat-icon>
                </button>
              </div>
            </div>
          </mat-list-item>
        </mat-list>
      </div>
      <div *ngIf="type == 'secondary'" class="containerDocs">
        <mat-list *ngIf="files.length">
          <mat-list-item [ngClass]="finish ? 'uploaddocs' : 'uploaddocsnew'"
            *ngFor="let doc of files, let i=index">
            <div mat-line class="my-auto d-md-inline-flex selectedFile">
              <div [matTooltip]="doc.name" class="uploaddocs__nameDoc">
                {{doc.name}}
              </div>
              <div class="uploaddocs__sizeDoc">
                {{doc.size | fileSize}}
              </div>
              <div>
                <button *ngIf="canRemoveDocument(i)" id="removeDelete" mat-icon-button (click)="remove($event, i);">
                  <mat-icon [ngClass]="finish ? 'deleteIconFinish' : 'deleteIconNew'"
                    class="deleteIcon">delete_outline</mat-icon>
                </button>
              </div>
            </div>
          </mat-list-item>
        </mat-list>
      </div>
    </div>
    <div class="m-0 mat-panel-footer" id="buttonPanel" *ngIf="!lite">
      <signaturit-button [disabled]="!files.length || disableButtons"
        text="{{ (deleteAll ? ('newcircuit_label_borrar_todos') : ('newcircuit_label_borrar')) | translate }}"
        type="tertiary" size="sm" (click)="clear()"></signaturit-button>
      <signaturit-button [disabled]="disableButtons" text="{{ 'newcircuit_label_seleccionar' | translate:_transParam }}"
        type="secondary" size="sm" (click)="openDialog()"></signaturit-button>
    </div>
  </div>
</div>